(function () {
  'use strict';

  function initGallery(root) {
    var mainImage = root.querySelector('[id^="ProductImage-"]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-product-thumb]'));
    if (!mainImage || thumbs.length === 0) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.dataset.full;
        mainImage.srcset = thumb.dataset.srcset;
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  }

  function initVariants(root) {
    var form = root.querySelector('#ProductForm');
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-product-option]'));
    var variantsScript = root.querySelector('[data-product-variants]');
    var pricesScript = root.querySelector('[data-product-variant-prices]');
    var variantIdInput = root.querySelector('[data-product-variant-id]');
    var priceEl = root.querySelector('[data-product-price]');
    var addToCartButton = root.querySelector('[data-product-add-to-cart]');

    if (!form || selects.length === 0 || !variantsScript || !variantIdInput) return;

    var variants = JSON.parse(variantsScript.textContent);
    var prices = pricesScript ? JSON.parse(pricesScript.textContent) : {};

    function findMatchingVariant() {
      var selectedOptions = selects.map(function (select) { return select.value; });
      return variants.filter(function (variant) {
        return selectedOptions.every(function (value, index) {
          return variant.options[index] === value;
        });
      })[0];
    }

    function updateForVariant(variant) {
      if (!variant) return;

      variantIdInput.value = variant.id;

      if (priceEl) {
        priceEl.textContent = variant.available ? (prices[variant.id] || '') : priceEl.dataset.soldOutLabel;
      }

      if (addToCartButton) {
        addToCartButton.disabled = !variant.available;
        addToCartButton.textContent = variant.available ? addToCartButton.dataset.availableLabel : addToCartButton.dataset.soldOutLabel;
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        updateForVariant(findMatchingVariant());
      });
    });
  }

  function initAll(container) {
    var scope = container || document;
    scope.querySelectorAll('.product').forEach(function (root) {
      initGallery(root);
      initVariants(root);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
